<nav class="navbar bg-white border-bottom flex-column">
  <div class="container d-flex justify-content-between align-items-center flex-wrap w-100">
    <div class="d-flex align-items-center gap-2 cursor_pointer" routerLink="/">
      <img src="/assets/images/main-logo.png" alt="Logo" class="main__logo-img" title="Logo: Works with homeXpert">
    </div>
    <div class="d-flex align-items-center gap-4 flex-wrap justify-content-end mt-2 mt-md-0">
      <!-- Desktop Search -->
      <div class="d-none d-sm-flex flex-column flex-sm-row align-items-center gap-1 header__main_icons position-relative">
        <i *ngIf="!searchActive()" class="bi bi-search fs-6 search-trigger" role="button"
            aria-label="Suche öffnen" (click)="toggleSearch()"></i>
        <span class="small cursor_pointer search-trigger" (click)="toggleSearch()">{{ 'nav.search' | translate }}</span>
        <div class="search-box" [class.active]="searchActive()">
          <i class="bi bi-search fs-6"></i>
          <input #searchInput type="text" placeholder="Suche..." class="search-input"
              [ngModel]="searchQuery()" (ngModelChange)="onSearchInput($event)"
              (keydown.escape)="toggleSearch()">
          <i class="bi bi-x-lg close-btn" role="button" aria-label="Suche schließen"
              (click)="toggleSearch()"></i>
        </div>
        <div class="search-results-dropdown" *ngIf="searchActive() && (searchQuery() || searchLoading())">
          <div *ngIf="searchLoading() && searchResults().length === 0" class="search-result-empty">
            <i class="bi bi-hourglass-split me-2"></i>{{ 'common.loading' | translate }}
          </div>
          <div *ngIf="!searchLoading() && searchQuery() && searchResults().length === 0" class="search-result-empty">
            {{ 'nav.noResults' | translate }}
          </div>
          <a *ngFor="let r of searchResults()" class="search-result-item" (click)="selectSearchResult(r)">
            <img *ngIf="r.imageUrl" [src]="r.imageUrl" alt="" class="search-result-img">
            <div class="search-result-info">
              <div class="search-result-name">{{ r.name }}</div>
              <div class="search-result-meta">
                <span class="badge bg-light text-secondary me-1">
                  {{ (r.type === 'package' ? 'nav.package' : 'nav.device') | translate }}
                </span>
                <span class="text-muted small">{{ r.type === 'package' ? r.manufacturer : r.packageName }}</span>
              </div>
            </div>
          </a>
        </div>
      </div>

      <!-- Mobile Search Trigger -->
      <div class="d-flex d-sm-none flex-column align-items-center gap-1 header__main_icons">
        <i class="bi bi-search fs-6 search-trigger" role="button" aria-label="Suche öffnen"
            (click)="toggleMobileSearch()"></i>
        <span class="small cursor_pointer search-trigger" (click)="toggleMobileSearch()">{{ 'nav.search' | translate }}</span>
      </div>

      <!-- Admin Link (nur für Admins) -->
      <div *ngIf="authService.isAdmin()" 
           class="d-flex flex-column flex-sm-row align-items-center gap-1 header__main_icons cursor_pointer"
           routerLink="/admin/products">
        <i class="bi bi-gear fs-6"></i>
        <span class="small">Admin</span>
      </div>

      <!-- Cart Icon (nur für angemeldete Benutzer) -->
      <div *ngIf="authService.isAuthenticated()" 
           class="d-flex flex-column flex-sm-row align-items-center gap-1 header__main_icons cursor_pointer position-relative"
           routerLink="/cart">
        <div class="position-relative">
          <i class="bi bi-cart3 fs-6"></i>
          <span *ngIf="cartService.hasItems()" 
                class="cart-badge position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
            {{ cartService.cartItemCount() }}
          </span>
        </div>
        <span class="small">{{ 'nav.cart' | translate }}</span>
      </div>

      <!-- User Menu (angemeldet) -->
      <div *ngIf="authService.isAuthenticated()" class="user-menu position-relative">
        <div class="d-flex flex-column flex-sm-row align-items-center gap-1 header__main_icons cursor_pointer"
             (click)="toggleUserMenu()">
          <i class="bi bi-person-circle fs-6"></i>
          <span class="small">{{ authService.user()?.firstName || 'Profil' }}</span>
          <i class="bi bi-chevron-down small ms-1"></i>
        </div>
        <div class="user-dropdown" [class.active]="userMenuOpen()">
          <a routerLink="/profile" class="dropdown-item" (click)="closeUserMenu()">
            <i class="bi bi-person me-2"></i>{{ 'nav.profile' | translate }}
          </a>
          <a routerLink="/inventory" class="dropdown-item" (click)="closeUserMenu()">
            <i class="bi bi-box-seam me-2"></i>{{ 'nav.inventory' | translate }}
          </a>
          <hr class="dropdown-divider">
          <a class="dropdown-item text-danger" (click)="logout()">
            <i class="bi bi-box-arrow-right me-2"></i>{{ 'nav.logout' | translate }}
          </a>
        </div>
      </div>

      <!-- Login Link (nicht angemeldet) -->
      <div *ngIf="!authService.isAuthenticated()" 
           class="d-flex flex-column flex-sm-row align-items-center gap-1 header__main_icons cursor_pointer"
           routerLink="/auth/login">
        <i class="bi bi-person-circle fs-6"></i>
        <span class="small">{{ 'nav.login' | translate }}</span>
      </div>

      <!-- Language Menu -->
      <div class="language-menu position-relative">
        <div class="d-flex flex-column flex-sm-row align-items-center gap-1 header__main_icons cursor_pointer"
             (click)="toggleLanguageMenu()">
          <img [src]="'/assets/flags/' + getCurrentFlag() + '.svg'" alt="" class="flag-icon">
          <i class="bi bi-chevron-down small ms-1"></i>
        </div>
        <div class="language-dropdown" [class.active]="languageMenuOpen()">
          @for (lang of languages; track lang.code) {
            <a class="dropdown-item" [class.active]="lang.code === currentLang" (click)="selectLanguage(lang.code)">
              <img [src]="'/assets/flags/' + lang.flag + '.svg'" alt="" class="flag-icon me-2">{{ lang.name }}
            </a>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Full-Width Search Row -->
  <div class="search-row w-100 bg-white px-3" [class.active]="mobileSearchActive()">
    <div class="search-box active">
      <i class="bi bi-search fs-6"></i>
      <input #mobileSearchInput type="text" placeholder="Suche..." class="search-input"
          [ngModel]="searchQuery()" (ngModelChange)="onSearchInput($event)"
          (keydown.escape)="toggleMobileSearch()">
      <i class="bi bi-x-lg close-btn" role="button" aria-label="Suche schließen"
          (click)="toggleMobileSearch()"></i>
    </div>
    <div class="search-results-dropdown search-results-dropdown--mobile" *ngIf="mobileSearchActive() && (searchQuery() || searchLoading())">
      <div *ngIf="searchLoading() && searchResults().length === 0" class="search-result-empty">
        <i class="bi bi-hourglass-split me-2"></i>{{ 'common.loading' | translate }}
        </div>
        <div *ngIf="!searchLoading() && searchQuery() && searchResults().length === 0" class="search-result-empty">
          {{ 'nav.noResults' | translate }}
        </div>
        <a *ngFor="let r of searchResults()" class="search-result-item" (click)="selectSearchResult(r)">
          <img *ngIf="r.imageUrl" [src]="r.imageUrl" alt="" class="search-result-img">
          <div class="search-result-info">
            <div class="search-result-name">{{ r.name }}</div>
            <div class="search-result-meta">
              <span class="badge bg-light text-secondary me-1">
                {{ (r.type === 'package' ? 'nav.package' : 'nav.device') | translate }}
              </span>
              <span class="text-muted small">{{ r.type === 'package' ? r.manufacturer : r.packageName }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
</nav>
